import React, { Component, Fragment } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
import axios from "axios";

// import { ToastContainer, toast } from "react-toastify"; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)
import parse from "html-react-parser";

class ReplayItem extends Component {
  state = {};
  _isMounted = false;
  componentDidMount = () => {
    this._isMounted = true;
    this._getReplay();
  };
  componentWillUnmount = () => {
    this._isMounted = false;
  };
  _getReplay = async () => {
    const { replay_idx } = this.props.childProps;
    //console.log(replay_idx)
    if (replay_idx === 0 || replay_idx === undefined || replay_idx === null) {
    } else {
      const result = await this._getReplayApi();
      const intReturn = result.data[0].intReturn;
      const replayList = result.data[0].listData;

      if (intReturn === 0) {
        if (this._isMounted) {
          this.setState({
            replayList,
          });
        }
      }
    }
  };
  _getReplayApi = () => {
    const { apiUrl } = this.props;
    const { replay_idx } = this.props.childProps;

    return axios
      .post(apiUrl + "/boardReplay", {
        params: {
          replay_idx: replay_idx,
        },
      })
      .then((response) => response)
      .catch((error) => {
        alert("오류가 발생했습니다.");
      });
  };
  _renderItem = () => {
    const { replayList } = this.state;

    const list = replayList.map((item, index) => {
      return (
        <div style={{ padding: 20, fontSize: 14, lineHeight: 5 }} key={index}>
          <p>[운영자의 답변 입니다.({item.regDate})]</p>
          {/*item.title*/}
          {parse(item.title)}
        </div>
      );
    });

    return list;
  };
  render() {
    const { replayList } = this.state;
    return <Fragment>{replayList ? this._renderItem() : null}</Fragment>;
  }
}

export default shopContext(withRouter(ReplayItem));
